const toggleFooterEcoText = () => {
  const moreText = document.getElementById('footer-eco-text-more');
  const toggleLink = document.getElementById('footer-eco-text-toggle');

  if (moreText.style.display === 'none') {
    moreText.style.display = 'inline';
    toggleLink.innerText = 'Close';
  } else {
    moreText.style.display = 'none';
    toggleLink.innerText = 'Read more';
  }
}
